module.exports = __webpack_public_path__ + "static/media/ic_covid_b_3_fisdom.466af210.svg";